export const classes = {
  wrapper: 'flex flex-col items-center px-0.5 pb-2.5 pt-1.5 text-center',
  tile: 'mb-6 flex size-[78px] items-center justify-center rounded-[22px]',
  success:
    'bg-[linear-gradient(135deg,#059669,#2dd4bf)] text-white shadow-[0_16px_34px_-12px_rgba(5,150,105,0.5)]',
  neutral:
    'bg-black/[0.08] text-taupe-1 dark:bg-white/[0.08] dark:text-mauve-3',
  danger: 'bg-[#e5484d]/[0.14] text-[#e5484d]',
  title:
    'mb-[11px] text-[22px] font-extrabold tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  message:
    'max-w-[322px] text-[14.5px] leading-[1.65] text-taupe-2 dark:text-mauve-2',
};
